<template>
    <div>
        <div style="border-bottom: 1px solid #eee;">
            <label for="upFile" class="up-button">
                <div class="label">上传单个/多个文件</div>
                <input type="file" id="upFile" class="up-file" multiple @change="handleFileSelect">
            </label>
        </div>
        <div>
            <label for="upFileDdirectory" class="up-button">
                <div class="label">上传整个文件夹</div>
                <input type="file" id="upFileDdirectory" class="up-file" webkitdirectory directory multiple
                    @change="handleFileSelect" />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        handleFileSelect(event) {
            this.$emit('handleFileSelect', event)
        }
    }
}
</script>

<style lang="scss" scoped>
.up-button {

    font-size: 12px;
    /* background-color: #4b92ff; */
    margin: 6px 0;
    display: block;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    border-radius: 3px;

    .label {
        padding: 6px;
        color: #606266;
    }

    :hover {
        background: #eee;
    }

    &:last-child {
        border: none;
    }
}

.up-file {
    border: none;
    display: none;
}

.input-file {
    display: none;
}
</style>